if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      if(this.querySelector('form')){
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }else {
        this.querySelector('[name=id]').disabled = false
         this.querySelector('button[type=submit]').addEventListener(
						'click',
						this.onSubmitHandler.bind(this)
					)
      }
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      // Skip loading class (hides text) — use text feedback instead
      //this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Save original button text and show 'Adding to cart...'
      const btnSpan = this.submitButton.querySelector('span') || this.submitButton;
      this._originalButtonText = btnSpan.textContent;
      btnSpan.textContent = 'Adding to cart...';

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
				formData.append('id', this.querySelector('[name=id]').value)
			}
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then(async (response) => {
          // Ensure "Adding to cart..." shows for at least 600ms
          await new Promise(r => setTimeout(r, 600));
          // CART ERROR EVENT
          if (response.status) {
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message
                }
              })
            );
            // -------------------------------------------
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            // Revert button text on error
            const errSpan = this.submitButton.querySelector('span') || this.submitButton;
            errSpan.textContent = this._originalButtonText || 'Add to Cart';

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          // VARIANT ADDED EVENT
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.section
              }
            })
          );
          // -------------------------------------------

          if (!this.error) {
            // Show 'Added ✓' confirmation
            const successSpan = this.submitButton.querySelector('span') || this.submitButton;
            successSpan.textContent = 'Added ✓';
            this.submitButton.style.backgroundColor = '#2e7d32';
            this.submitButton.style.color = '#fff';
            setTimeout(() => {
              successSpan.textContent = this._originalButtonText || 'Add to Cart';
              this.submitButton.style.backgroundColor = '';
              this.submitButton.style.color = '';
            }, 3000);

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });

            // CART CHANGE EVENT
            const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
              ? window.Shopify.routes.root + 'cart.js'
              : '/cart.js';
            fetch(cartUrl).then((r) => r.json()).then((cart) => {
              document.dispatchEvent(
                new CustomEvent("cart:change", { detail: { cart }, bubbles: true })
              );
            }).catch(() => {});
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) quickAddModal.hide(true);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          //this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
